import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";

class Boletinage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nivelUsuario: localStorage.nivel_actual,
    };
  }
  anotacionMarginal = "";
  componentDidMount() {
    // si el usuario no es nivel administrador ipsa redireccionamos a home
    if (!["2", "3"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getNotificacionesBoletin",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        asunto: {
          label: "Asunto",
        },
        fecha_envio: {
          label: "Fecha",
        },
        /*recurrente: {
          label: "Recurrente"
        },
        grupo:{
          label:"Grupo"
        },*/
        acceso: {
          label: "Acceso",
        },
      },
      buttons: [
        {
          iconClass: "fa fa-eye",
          btnClass: "btn btn-primary",
          btnClick: (data) => {
            Api.loading(1);
            Api.fetch("app/getNotificacion?id=" + data.id).then((nota) => {
              Api.loading(0);
              ver.merge(nota);
              Swal.fire({
                title: "Notificación",
                html: ver,
                width: "48em",
                cancelButtonText: "Regresar",
                cancelButtonColor: "red",
                showCancelButton: true,
                showConfirmButton: false,
                reverseButtons: true,
                showLoaderOnConfirm: true,
                /*preConfirm: (data) => {
                  Swal.showLoading();
                  return  Api.fetch("app/crearNotificacion",crear.data(),'post').then((data) => {
                    if (data) {
                      mi_grid.go(1);
                    }
                  });
                }*/
              });
            });
            return;
          },
        },
        /*{
            iconClass: "fa fa-trash",
            btnClass: "btn bg-gradient-danger",
            btnClick: data => {
            
              Swal.fire({
                title: "¿Seguro que desea eliminar esta notificación?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Regresar",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  Api.loading(true);
                  Api.fetch(
                    "app/eliminarNotificacion",
                    {
                      id: data.id
                    },
                    "POST"
                  ).then((r) => {
                    Api.loading(false);
                    mi_grid.go(1);
                  });
                }
              });
            }
           }*/
      ],
    };

    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "asunto",
            label: "Asunto",
            placeHolder: "Asunto",
            cols: 5,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_inicio",
            label: "Fecha desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_hasta",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 1,
            text: "",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              mi_grid.go(1, src);
            },
          },
        },
        {
          button: {
            name: "agregar",
            class: "form-control btn-success",
            icon: "fa fa-plus",
            cols: 2,
            text: "Crear",
            click: (e) => {
              crear.clear();
              Swal.fire({
                title: "Crear notificación",
                html: crear,
                width: "48em",
                confirmButtonText: "Continuar",
                cancelButtonText: "Regresar",
                showCancelButton: true,
                reverseButtons: true,
                showLoaderOnConfirm: true,
                cancelButtonColor: "Red",
                confirmButtonColor: "#4CD964",		
                preConfirm: (data) => {
                  Swal.showLoading();
                  return Api.fetch(
                    "app/crearNotificacion",
                    crear.data(),
                    "post"
                  ).then((data) => {
                    if (data) {
                      Swal.fire({
                        title: "Éxito",
                        text: `La notificación se ha envidado exitosamente.`,
                        icon: "success",
                      });
                      mi_grid.go(1);
                    }
                  });
                },
              });
            },
          },
        },
      ],
    });

    let crear = Api.form({
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "hidden",
            name: "id",
          },
        },
        {
          input: {
            type: "text",
            name: "asunto",
            label: "Asunto",
            placeHolder: "Asunto",
            cols: 12,
            value: "",
          },
        },
        {
          textarea: {
            name: "contenido",
            label: "Mensaje",
            placeHolder: "Mensaje de notificación",
            rows: 6,
            cols: 12,
            value: "",
          },
        },
        {
          select: {
            name: "sys_acceso",
            label: "Acceso",
            cols: 12,
            render: (e) => {
              Api.fetch("app/getNotifyAccesos").then((data) => {
                let options = '<option value="">Seleccione...</option>';
                data.forEach((grupo) => {
                  options += `<option value="${grupo.id}">${grupo.descripcion}</option>`;
                });
                e.innerHTML = options;
              });
            },
          },
        },
      ],
    });

    let ver = Api.form({
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "hidden",
            name: "id",
          },
        },
        {
          input: {
            readOnly: true,
            type: "text",
            name: "asunto",
            label: "Asunto",
            placeHolder: "Asunto",
            cols: 12,
            value: "",
          },
        },
        {
          textarea: {
            readOnly: true,
            name: "contenido",
            label: "Mensaje",
            rows: 6,
            cols: 12,
            value: "",
          },
        },
        {
          input: {
            readOnly: true,
            type: "date",
            name: "fecha_envio",
            label: "Fecha de envío",
            placeHolder: "fecha",
            cols: 6,
            value: "",
          },
        },
        {
          select: {
            disabled: true,
            name: "sys_acceso",
            label: "Acceso",
            cols: 6,
            render: (e) => {
              Api.fetch("app/getNotifyAccesos").then((data) => {
                let options = '<option value="">Seleccione...</option>';
                data.forEach((grupo) => {
                  options += `<option value="${grupo.id}">${grupo.descripcion}</option>`;
                });
                e.innerHTML = options;
              });
            },
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Inicio</li>
          <li className="breadcrumb-item active">Notificaciones</li>
        </ol>
        <h1 className="page-header">Notificaciones</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default Boletinage;
